import Menu, { MenuProps } from "@mui/material/Menu";

import { useForwardPointerEvents } from "shared/common/hooks/UseForwardPointerEvents";

interface CustomMenuProps extends MenuProps {
  onForwardedPointerEvent?: (e: React.PointerEvent) => void;
}

export default function MenuWithPointerForwarding({
  onForwardedPointerEvent,
  onClose,
  slotProps,
  ...menuProps
}: CustomMenuProps) {
  const handlePointerEvent = useForwardPointerEvents(
    onForwardedPointerEvent,
    onClose
  );

  return (
    <Menu
      {...menuProps}
      onClose={onClose}
      slotProps={{
        ...slotProps,
        backdrop: {
          style: { touchAction: "none", userSelect: "none" },
          onPointerDown: handlePointerEvent,
          onPointerMove: handlePointerEvent,
          onPointerUp: handlePointerEvent,
          onPointerCancel: handlePointerEvent,
          ...(slotProps?.backdrop || {}),
        },
      }}
    >
      {menuProps.children}
    </Menu>
  );
}
